import { createTRPCUntypedClient, httpLink } from '@trpc/client';
import {
  imagesUploadInputSchema,
  imagesDeleteInputSchema,
  profileImageUploadInputSchema,
  profileImageDeleteInputSchema,
  imagesUploadSuccessSchema,
  imagesDeleteSuccessSchema,
  profileImageUploadSuccessSchema,
  profileImageDeleteSuccessSchema,
  type ImagesUploadInput,
  type ImagesDeleteInput,
  type ProfileImageUploadInput,
} from '@charitystack/org-engagement-contracts';

/** D-015 L-2: typed shared contracts, never a cross-boundary backend router import.
 * Not selected by callers until INF-102's cutover; constructing it moves no traffic.
 */
export function createImagesClient(options: {
  url: string;
  authorization: string;
  fetch?: typeof fetch;
}) {
  const client = createTRPCUntypedClient({
    links: [
      httpLink({
        url: options.url,
        fetch: options.fetch,
        headers: () => ({
          authorization: options.authorization,
          'x-cs-authorization': options.authorization,
        }),
      }),
    ],
  });
  return {
    async uploadImage(input: ImagesUploadInput) {
      return imagesUploadSuccessSchema.parse(
        await client.mutation('org.images.uploadImage', imagesUploadInputSchema.parse(input)),
      );
    },
    async deleteImage(input: ImagesDeleteInput) {
      return imagesDeleteSuccessSchema.parse(
        await client.mutation('org.images.deleteImage', imagesDeleteInputSchema.parse(input)),
      );
    },
    async uploadProfileImage(input: ProfileImageUploadInput) {
      return profileImageUploadSuccessSchema.parse(
        await client.mutation(
          'org.images.uploadProfileImage',
          profileImageUploadInputSchema.parse(input),
        ),
      );
    },
    async deleteProfileImage() {
      return profileImageDeleteSuccessSchema.parse(
        await client.mutation(
          'org.images.deleteProfileImage',
          profileImageDeleteInputSchema.parse({}),
        ),
      );
    },
  };
}
